module.exports = __webpack_public_path__ + "img/1.c949f67b.jpg";